module.exports = __webpack_public_path__ + "img/credit-card.b0e1dbfb.svg";